<template>
	<div id='footer'>
		<div class='footer-logo'></div>
		<div class='footer-column'>

			<div v-for='nav in footer.navigation'  v-bind:key='nav.link'>
				<div class='subnav'>
					<router-link :to="{ path: nav.link }" @click.native="scrollToTop">{{nav.title}}</router-link>
				</div>

			</div>
<!-- 			<div class='subnav'>
                <router-link :to="{ path: 'termine' }" @click.native="scrollToTop">Termin Buchen</router-link>
			</div>
			<div class='subnav'>
                <router-link :to="{ path: 'impressum' }" @click.native="scrollToTop">Impressum</router-link>
			</div>
			<div class='subnav'>
                <router-link :to="{ path: 'datenschutz' }" @click.native="scrollToTop">Datenschutz</router-link>

			</div>		 -->
		</div>
		<div class='footer-column'>
			<div class='subnav'>
				{{footer['seo-headline']}}
			</div>
		</div>
		<div class='footer-column'>
			<div class='subnav'>
				{{footer['kontakt-headline']}}
			</div>
			<div class='info-box' v-html="footer['kontakt-text'][0].text"></div>
		</div>
<!-- 		<div class='footer-column'>
			<div class='subnav'>
				Folgen Sie uns
			</div>
			<div class='info-box'>

			</div>
		</div>	 -->
	</div>
</template>

<script>
	export default {
		name: 'footerel',
		props: {
			footer: Array,

		},
		data() {
			return {
		        isMenu: false
			}
		},
		watch:{

		},

		methods: {
	            scrollToTop() {
                window.scrollTo(0,0);
            },

		}
	}
</script>

<style lang="less">

@import '../less/variables.less';

#footer {
  position: relative;
  min-height: 140px;
  width: 90%;
  background-color: black;
  // bottom: 20px;
  // right: 0px;
  .fm(12px);
  letter-spacing: 1.5px;
  line-height: 40px;
  text-align: left;
  padding: 50px 5%;
  vertical-align: top;
  // padding-right: 5%;
  a {
    color: white;
    text-decoration: none;
  }
  .footer-nav {
    display: inline-block;
    margin-left: 40px;
    text-transform: uppercase;
  }
  .footer-column {
  	margin-top: 7px;

	background-image: url('/images/tl-bracket.svg');
	background-position: left top;
	background-repeat: no-repeat;
	display: inline-block;
	// background-color: red;
	vertical-align: top;
	// margin-left: 80px;
	padding-top: 10px;
	padding-left: 25px;
	margin-bottom: 50px;
	margin-right: 3%;
	min-width: 240px;
	max-width: 20%;



	.subnav {
		.fmb(12px);
		padding-left: 0px;
		text-transform: uppercase;
		cursor: pointer;
		margin-bottom: 10px;
		&:hover {
			opacity: 0.7;
		}
	}
	.info-box {
		.fm(11px);
		opacity: 0.8;
	}
  }

	.footer-logo {
		background-image: url('/images/logo.svg');
		background-position: left center;
		background-repeat: no-repeat;
		background-size: 100% auto ;
		width: 100px;
		height: 90px;
		display: inline-block;
		margin-right: 80px;
		// float: left;
		// background-color: red;
		// margin-right: 40px;

}
}

</style>
